import api from '../../../../../api/client'

export async function listAccountHeads(params) {
  const { data } = await api.get('/masters/ac-heads/', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function getAccountHeadDetail(id) {
  const { data } = await api.get(`/masters/ac-heads/${id}`)
  return data
}

export async function createAccountHead(payload) {
  const { data } = await api.post('/masters/ac-heads/', payload)
  return data
}

export async function updateAccountHead(id, payload) {
  const { data } = await api.put(`/masters/ac-heads/${id}`, payload)
  return data
}

export async function deleteAccountHead(id) {
  const { data } = await api.delete(`/masters/ac-heads/${id}`)
  return data
}

export async function archiveAccountHead(id) {
  const { data } = await api.post(`/masters/ac-heads/${id}/archive`)
  return data
}

export async function getAcGroups() {
  const { data } = await api.get('/masters/ac-heads/groups/list')
  return data
}
